import { render, staticRenderFns } from "./BulkClassifyForm.vue?vue&type=template&id=627e7950"
import script from "./BulkClassifyForm.vue?vue&type=script&lang=js"
export * from "./BulkClassifyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports